'use client';

import type * as React from 'react';

import type { Switch as SwitchPrimitive } from 'radix-ui';

import { Switch } from './switch';

import { Label } from '../typography';

export function LabeledSwitch({
  label,
  labelPlacement = 'after',
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root> & {
  label: string;
  labelPlacement?: 'before' | 'after';
}) {
  return (
    <Label className="flex items-center gap-2">
      {labelPlacement === 'before' && label}
      <Switch {...props} />
      {labelPlacement === 'after' && label}
    </Label>
  );
}
